var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "        <button id=\"esToggleSimple\" type=\"button\" class=\"btn btn-mini btn-hvr btn-hvr-border\">S</button>\n\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.showGrepBtn : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "            <button id=\"esToggleGrep\" type=\"button\" class=\"btn btn-mini btn-hvr btn-hvr-border\">\n                <i class=\"icon-filter\"></i>\n            </button>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "        <div id=\"esNoResults\">\n            <i class=\"icon-attention-circled\"></i>\n            No Hits\n        </div>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.showHitNav : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data) {
    return "            <div class=\"esNAV\"></div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div id=\"esFootLeft\">\n\n    <button id=\"esToggleHits\" type=\"button\" class=\"btn btn-mini btn-hvr btn-hvr-border\">HITS</button>\n\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.docOnServerAndNoFetchErr : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n</div>\n\n<div id=\"esFootCenter\"></div>\n\n<div id=\"esFootRight\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showNoResultsFoundIndicator : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data})) != null ? stack1 : "")
    + "</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/layout/footer/template.hbs
 ** module id = 538
 ** module chunks = 0
 **/